import syncMetadata from '@sync/sync.metadata';
import { SyncMode } from '@sync/types';

export const Sync =
  (mode: SyncMode, indexedKeys?: string[]): ClassDecorator =>
  (target): void => {
    syncMetadata.entites.push({ target, mode, indexedKeys });
  };
